var menus = [
  {
    path: '/investment',
    name: 'การลงทุนของฉัน',
    icon: 'PortfolioIcon',
    component: 'INVESTMENT',
    layout: '/main',
    section: 'user',
    onSidebar: true,
    showTitle: true,
    subMenus: [
      {
        path: '/investment/information',
        name: 'Information',
        icon: 'InformationIcon',
        component: 'INFORMATION',
        layout: '/main'
      },
      {
        path: '/investment/portfolio',
        name: 'Portfolio',
        icon: 'PortfolioIcon',
        component: 'PORTFOLIO',
        layout: '/main'
      },
      {
        path: '/investment/order',
        name: 'Order',
        icon: 'OrderStatusIcon',
        component: 'ORDER',
        layout: '/main'
      },
      {
        path: '/investment/lot',
        name: 'LOT',
        icon: '',
        component: 'LOT',
        layout: '/main'
      },
      {
        path: '/investment/book',
        name: 'Book',
        icon: '',
        component: 'BOOK',
        layout: '/main'
      },
      {
        path: '/investment/history',
        name: 'History',
        icon: 'HistoricalTradeIcon',
        component: 'HISTORY',
        layout: '/main'
      },
      {
        path: '/investment/dca',
        name: 'DCA',
        icon: '',
        component: 'DCA',
        layout: '/main'
      },
      {
        path: '/investment/div',
        name: 'DIV',
        icon: '',
        component: 'DIV',
        layout: '/main'
      }
    ],
    isLoggedIn: true
  },
  {
    path: '/investment/order',
    name: 'รายการซื้อขาย',
    icon: 'OrderStatusIcon',
    // component: 'ORDER',
    layout: '/main',
    section: 'user',
    onSidebar: true,
    showTitle: true,
    isLoggedIn: true
  },
  {
    path: '/order-confirm',
    name: 'ส่งคำสั่ง',
    icon: 'SentOrderIcon',
    component: 'SENT_ORDER',
    layout: '/main',
    section: 'user',
    onSidebar: true,
    showTitle: true,
    isLoggedIn: true
  },
  {
    path: '/order_request',
    name: 'ส่งคำสั่ง',
    icon: 'SentOrderIcon',
    component: 'ORDER_REQUEST',
    layout: '/main',
    section: 'user',
    onSidebar: false,
    showTitle: true,
    isLoggedIn: true
  },
  {
    path: '/favorite',
    name: 'รายการโปรด',
    icon: 'FavoriteIcon',
    component: 'FAVORITE',
    layout: '/main',
    section: 'user',
    onSidebar: true,
    showTitle: true,
    isLoggedIn: true
  },
  {
    path: '/monthly-report',
    name: 'รายงานรายเดือน',
    icon: 'MonthlyReportIcon',
    component: 'MONTHLY_REPORT',
    layout: '/main',
    section: 'user',
    onSidebar: true,
    showTitle: true,
    isLoggedIn: true
  },
  {
    path: '/fund_ranking',
    name: 'จัดอันดับกองทุน',
    icon: 'FundRankingIcon',
    component: 'FUND_RANKING',
    layout: '/main',
    section: 'main',
    onSidebar: true,
    showTitle: true,
    searchAble: true,
    isLoggedIn: false
  },
  {
    path: '/hotfund',
    name: 'กลุ่มกองทุนมาแรง',
    icon: 'HotFundIcon',
    component: 'HOTFUND',
    layout: '/main',
    section: 'main',
    onSidebar: true,
    showTitle: true,
    searchAble: true,
    isLoggedIn: false
  },
  {
    path: '/compare',
    name: 'เปรียบเทียบกองทุน',
    icon: 'CompareIcon',
    component: 'COMPARE',
    layout: '/main',
    section: 'main',
    onSidebar: true,
    showTitle: true,
    subMenus: [
      {
        path: '/compare/fund_compare',
        name: 'ข้อมูล',
        icon: 'FundCompareIcon',
        component: 'FUND_COMPARE',
        layout: '/main'
      },
      /* {
        path: '/compare/copyport_compare',
        name: 'CopyportCompare',
        icon: 'PortIcon',
        component: 'COPYPORT_COMPARE',
        layout: '/main'
      }, */
      {
        path: '/compare/graph_compare',
        name: 'กราฟ',
        icon: 'ChartIcon',
        component: 'GRAPH_COMPARE',
        layout: '/main'
      }
    ],
    isLoggedIn: false
  },
  {
    path: '/search',
    name: 'สแกนหากองทุน',
    icon: 'SearchAdvanceIcon',
    component: 'ADVANCE_SEARCH',
    layout: '/main',
    section: 'main',
    onSidebar: true,
    showTitle: true,
    /*subMenus: [
      {
        path: '/search/fund',
        name: 'กองทุน',
        icon: '',
        component: 'ADVANCE_SEARCH_FUND',
        layout: '/main'
      },
       {
        path: '/search/copyport',
        name: 'Copyport',
        icon: '',
        component: 'ADVANCE_SEARCH_COPYPORT',
        layout: '/main'
      },
    ]*/
  },
  {
    path: '/ipo',
    name: 'กองทุน IPO',
    icon: 'IPOFundIcon',
    component: 'IPO',
    layout: '/main',
    section: 'main',
    onSidebar: true,
    showTitle: false,
    subMenus: [
      {
        path: '/ipo/fund_ipo',
        name: 'FUND IPO',
        icon: 'IPOFundIcon',
        component: 'FUND_IPO',
        layout: '/main'
      },
      {
        path: '/ipo/term_fund',
        name: 'Term Fund',
        icon: 'IPOFundIcon',
        component: 'TERM_FUND',
        layout: '/main'
      },
      {
        path: '/ipo/rollover',
        name: 'Rollover',
        icon: 'IPOFundIcon',
        component: 'ROLLOVER',
        layout: '/main'
      }
    ],
    isLoggedIn: false
  },
  // {
  //   path: '/transfer',
  //   name: 'โอนกองทุนมาโนมูระ',
  //   icon: 'TransferIcon',
  //   component: 'TRANSFER',
  //   layout: '/main',
  //   section: 'other',
  //   onSidebar: true,
  //   showTitle: true,
    // isLoggedIn: true
  // },
  {
    path: '/calendar',
    name: 'ปฏิทินกองทุน',
    icon: 'CalendarIcon',
    component: 'CALENDAR',
    layout: '/main',
    section: 'other',
    onSidebar: true,
    showTitle: true,
    isLoggedIn: false
  },
  {
    path: '/download_form',
    name: 'แบบฟอร์มการลงทุน',
    icon: 'DocumentIcon',
    component: 'DOWNLOAD_FORM',
    layout: '/main',
    section: 'other',
    onSidebar: true,
    showTitle: true,
    isLoggedIn: true
  },
  {
    path: '/faq',
    name: 'แนะนำฟังชั่นและ FAQ',
    icon: 'FAQIcon',
    component: 'FAQ',
    layout: '/main',
    section: 'other',
    onSidebar: true,
    showTitle: true,
    isLoggedIn: false
  },
  {
    path: '/fund_information',
    name: 'ข้อมูลกองทุน',
    icon: '',
    component: 'FUND_INFORMATION',
    layout: '/main',
    section: 'other',
    onSidebar: false,
    showTitle: true,
    isLoggedIn: false
  },
  {
    path: '/ui_kit',
    name: 'UI Kits',
    icon: 'fas fa-main',
    component: 'UI_KIT',
    layout: '/blank',
    onSidebar: false,
    showTitle: true,
    isLoggedIn: false
  },
  {
    path: '/home',
    name: 'Home',
    icon: 'HomeIcon',
    component: 'HOME',
    layout: '/main',
    section: 'other',
    onSidebar: false,
    showTitle: false,
    isLoggedIn: false
  },
  {
    path: '/ad_login',
    name: 'AD Login',
    // icon: 'HomeIcon',
    component: 'AD_LOGIN',
    layout: '/main',
    // section: 'other',
    onSidebar: false,
    // showTitle: false,
    isLoggedIn: false
  },
  {
    path: '/dsa',
    name: 'DSA Login',
    // icon: 'HomeIcon',
    component: 'DSA_LOGIN',
    layout: '/main',
    // section: 'other',
    onSidebar: false,
    // showTitle: false,
    isLoggedIn: false
  },
  {
    path: '/sso',
    name: 'SSO Login',
    // icon: 'HomeIcon',
    component: 'SSO_LOGIN',
    layout: '/main',
    // section: 'other',
    onSidebar: false,
    // showTitle: false,
    isLoggedIn: false
  },
  {
    path: '/sign_out',
    name: 'SIGN OUT',
    component: 'SIGN_OUT',
    layout: '/main',
    onSidebar: false,
    isLoggedIn: false
  },
];

export default menus;
